// extracted by mini-css-extract-plugin
export default {"box":"GradientLoadingBox__box___mOTUv","placeHolderShimmer":"GradientLoadingBox__placeHolderShimmer___VU3C8"};